module.exports = __webpack_public_path__ + "static/img/show-tab.74e8d512.png";